const SWR_KEYS = {
  //USERS
  getUserById: "getUserById",
  getUsers: "getUsers",
  getUserPermissions: "getUserPermissions",

  //PROFILES
  getAllProfiles: "getAllProfiles",

  //SKUs
  getSkus: "getSkus",
  getSkuById: "getSkuById",

  //ListPrice
  getListPrices: "getListPrices",
  getListPriceById: "getListPriceById",

  //Kit
  getKitById: "getKitById",

  //Products
  getProductById: "getProductById",
  getProducts: "getProducts",

  //Products Images
  getProductImageById: "getProductImageById",
  getProductImages: "getProductImages",

  //CategoryProducts
  getCategories: "getCategories",
  getCategoryById: "getCategoryById",

  //ProductVariations
  getProductVariations: "getProductVariations",
  getProductVariationById: "getProductVariationById",

  //Contacts
  getContacts: "getContacts",
  getContactById: "getContactById",

  //TAGS
  getTags: "getTags",
  getTagById: "getTagById",

  //CITIES TAGS
  getTagCities: "getTagCities",

  //Campaign
  getCampaigns: "getCampaigns",
  getCampaignById: "getCampaignById",
  getSegmentContacts: "getSegmentContacts",

  //Campaign Simple Message
  getCampaignSimpleMessages: "getCampaignSimpleMessages",
  getCampaignSimpleMessageById: "getCampaignSimpleMessageById",

  //Campaign Logs
  getCampaignLogs: "getCampaignLogs",

  //Campaign Statistics
  getCampaignStatistics: "getCampaignStatistics",

  //Campaign Templates
  getCampaignTemplates: "getCampaignTemplates",

  //Orders
  getOrders: "getOrders",
  getOrderById: "getOrderById",
  getOrderPdf: "getOrderPdf",

  //Messages
  getMessages: "getMessages",
  getMessageById: "getMessageById",
  getChatDetail: "getChatDetail",
  getAllChats: "getAllChats",
  getUnreadConversationsCount: "getUnreadConversationsCount",

  //Media
  getMediaById: "getMediaById",
  downloadMedia: "downloadMedia",

  //Conversations
  getConversationReport: "getConversationReport",
  getConversationDetails: "getConversationDetails",
  getConversationMessages: "getConversationMessages",
  checkExistingConversation: "checkExistingConversation",

  //ContactPlatform
  getContactPlatformById: "getContactPlatformById",

  //CustomerPlataform
  getCustomerPlatforms: "getCustomerPlatforms",

  //Customer
  getCustomers: "getCustomers",
  getCustomerById: "getCustomerById",

  //Workflow
  getWorkflowById: "getWorkflowById",
  getWorkflows: "getWorkflows",
  getAllWorkflowTypes: "getAllWorkflowTypes",
  getAllWorkflows: "getAllWorkflows",
  getGlobalVariables: "getGlobalVariables",

  //Workflow Steps
  getWorkflowSteps: "getWorkflowSteps",
  getWorkflowStepById: "getWorkflowStepById",

  //Workflow Engine
  getWorkflowEngineBackoffice: "getWorkflowEngineBackoffice",
  getWorkflowEngineById: "getWorkflowEngineById",

  //Workflow Elements
  getAllWorkflowElementsBackoffice: "getAllWorkflowElementsBackoffice",
  getWorkflowElementById: "getWorkflowElementById",

  //Platforms
  getPlatforms: "getPlatforms",
  selectedPlatformId: "selectedPlatformId",
  platformsList: "platformsList",

  //Customer Sales Product
  getCustomerSalesProducts: "getCustomerSalesProducts",
  getCustomerSalesProductById: "getCustomerSalesProductById",
  getAllCustomerSalesProducts: "getAllCustomerSalesProducts",

  //Sales Product Price
  getSalesProductPrice: "getSalesProductPrice",
  getSalesProductPriceById: "getSalesProductPriceById",

  //Sales Product
  getSalesProduct: "getSalesProduct",
  getSalesProductById: "getSalesProductById",

  //Customer Sales ProductPayments
  getCustomerSalesProductPayments: "getCustomerSalesProductPayments",
  getCustomerSalesProductPaymentById: "getCustomerSalesProductPaymentById",

  //Stock
  getStockMovements: "getStockMovements",

  // ExecutionLog
  getExecutionLogs: "getExecutionLogs",

  //Coverage Area
  getCoverageAreas: "getCoverageAreas",
  getCoverageAreaById: "getCoverageAreaById",

  //Service Queue
  getServiceQueues: "getServiceQueues",
  getServiceQueueById: "getServiceQueueById",
  getServiceQueuesByUser: "getServiceQueuesByUser",
  getSubjects: "getSubjects",
  getSubjectById: "getSubjectById",

  //T2 pay
  getDocumentation: "getDocumentation",
  getAccountBalance: "getAccountBalance",
  getAccountStatus: "getAccountStatus",
  getAccountFees: "getAccountFees",
  getTalk2PayFees: "getTalk2PayFees",
  getAccountAnticipation: "getAccountAnticipation",
  getCommercialInfo: "getCommercialInfo",
  getBankAccounts: "getBankAccounts",
  getBanks: "getBanks",
  getFinancialTransaction: "getFinancialTransaction",
  getPaymentTypes: "getPaymentTypes",
  getAvailablePaymentTypes: "getAvailablePaymentTypes",
  getPaymentTypeById: "getPaymentTypeById",

  //Customer Configuration
  getCustomerConfigurationById: "getCustomerConfigurationById",
  getCustomerConfigurations: "getCustomerConfigurations",
  getAllCustomerConfigurations: "getAllCustomerConfigurations",

  //Service Hours
  getServiceHours: "getServiceHours",

  //Closed Days
  getClosedDays: "getClosedDays",

  // Freight
  getFreightTypes: "getFreightTypes",

  //Notifications
  getNotifications: "getNotifications",
  getNotificationsById: "getNotificationsById",

  //Importations
  getImportations: "getImportations",

  //ImportationDetails
  getImportationDetails: "getImportationDetails",

  //Renew
  getRenewTotalById: "getRenewTotalById",

  //Service Interface (Integrations)
  getServiceInterfaces: "getServiceInterfaces",
  getServiceInterfaceSettings: "getServiceInterfaceSettings",
  getServiceInterfaceLogs: "getServiceInterfaceLogs",
  getServiceInterfaceLogTypes: "getServiceInterfaceLogTypes",

  //Message Templates (CustomerTemplate)
  getMessageTemplates: "getMessageTemplates",
  getMessageTemplateById: "getMessageTemplateById",
  getMessageTemplateTags: "getMessageTemplateTags",

  // Service dashboard
  getOperationalDashboard: "getOperationalDashboard",
  getManagerialDashboard: "getManagerialDashboard",
};

export default SWR_KEYS;
